import { useLocale, useTranslations } from 'next-intl';
import { Option } from 'types/Option';
import { sortByLocale } from 'utils/sortingMethods';

interface IUseOptionsPoCodeIn {
  noAny?: boolean;
}

interface IUseOptionsPoCodeOut {
  optionsPoCode: Option[];
}

export const PoCodeConst = ['with', 'without'];

export default function useOptionsPoCode(
  { noAny }: IUseOptionsPoCodeIn = { noAny: false }
): IUseOptionsPoCodeOut {
  const t = useTranslations();
  const locale = useLocale();

  const optionsPoCodeInitial = noAny
    ? []
    : [{ label: t('ordering_form.qualities.any'), value: undefined }];

  const optionsPoCode =
    [
      ...optionsPoCodeInitial,
      ...PoCodeConst?.reduce(
        (acc, value) => [
          ...acc,
          { label: t(`billing.transactions.po_code.${value}` as any), value: value }
        ],
        [] as Option[]
      ).sort((first, second) => sortByLocale(locale)(first.label, second.label))
    ] ?? optionsPoCodeInitial;

  return { optionsPoCode };
}
